import React from 'react';
import PropTypes from 'prop-types';
import { SeriesStatusMessageWrapper, PipeWrapper, MessageWrapper, BroadcastsWrapper } from './SeriesStatusMessageLayer.style';
import getSeriesStatusMessage from '../../utils/getSeriesStatusMessage';
import Skeleton from '@mlb/react-patterns/v4/components/Skeleton/skeleton';
import GameStateTypes from 'bdata-sns-shared/game/types/GameStateTypes';
import fetchImgAsset from 'bdata-sns-shared/mini/utils/fetchImgAsset';

const SeriesStatusMessage = ({
    seriesStatus = {},
    dictionary = {},
    hideGameNumber,
    broadcasts = {},
    isLoading,
    assetsBaseUrl,
    gameState,
    ifNecessary,
    gameType,
    leagueID
}) => {
    const messages = getSeriesStatusMessage({
        ...seriesStatus,
        hideGameNumber,
        dictionary,
        ifNecessary,
        gameType,
        leagueID
    });

    const { statusText, seriesTextAbbrev } = messages;
    const seriesExtendedText = statusText;
    const { id } = broadcasts;
    const pipe = seriesExtendedText ? (<PipeWrapper>|</ PipeWrapper>) : '';

    const Broadcasts = broadcasts && broadcasts.id && gameState !== GameStateTypes.FINAL ? (
        isLoading
            ? <Skeleton height={ 12 } width={ 45 } margin={ 0 } />
            : <BroadcastsWrapper>{ fetchImgAsset(`/images/tv_station/light/${id}.svg`, assetsBaseUrl, { alt: 'tv logo' }) }</BroadcastsWrapper>
    )
        : null;
    return (
        <SeriesStatusMessageWrapper>
            <MessageWrapper>
                { seriesTextAbbrev }
                { pipe }
                {seriesExtendedText}
            </MessageWrapper>
            { Broadcasts }
        </SeriesStatusMessageWrapper>
    );
};

SeriesStatusMessage.propTypes = {
    dictionary: PropTypes.object,
    seriesStatus: PropTypes.object,
    hideGameNumber: PropTypes.bool,
    broadcasts: PropTypes.object,
    isLoading: PropTypes.bool,
    assetsBaseUrl: PropTypes.string,
    gameState: PropTypes.string,
    ifNecessary: PropTypes.string,
    leagueID: PropTypes.string,
    gameType: PropTypes.string
};

export default SeriesStatusMessage;
